import { c as t } from "../../../../index.esm-BeDSGXP5.js";
import { css as e } from "styled-components";
const a = {
  base: () => /* @__PURE__ */ e([
    "height:auto;svg{height:100%;width:100%;}"
  ]),
  capitalOne: {
    wrapper: () => /* @__PURE__ */ e([
      "",
      ""
    ], t({
      width: [
        67,
        null,
        112
      ]
    }))
  },
  postOffice: {
    wrapper: () => /* @__PURE__ */ e([
      "display:flex;flex-direction:column;align-items:center;width:15rem;height:auto;"
    ]),
    postOfficeWrapper: () => /* @__PURE__ */ e([
      "",
      " svg{height:100%;width:100%;}"
    ], t({
      width: [
        "10rem",
        null,
        "15rem"
      ],
      height: [
        "8rem",
        null,
        "10rem"
      ]
    })),
    capitalOneWrapper: () => /* @__PURE__ */ e([
      "display:flex;align-items:center;height:3rem;svg{height:100%;width:100%;max-width:9rem;margin-top:-0.3rem;}"
    ]),
    poweredByText: ({ theme: i }) => /* @__PURE__ */ e([
      "font-size:1.2rem;font-weight:",
      ";line-height:1;margin-right:0.5rem;flex-shrink:0;"
    ], i.fontWeights.regular),
    capitalOneWrapperVariant1: () => /* @__PURE__ */ e([
      "display:flex;align-items:center;",
      " svg{height:100%;width:100%;max-width:6.2rem;max-height:2.3rem;}"
    ], t({
      marginLeft: [
        "0.5rem",
        null,
        0
      ]
    })),
    postOfficeWrapperVariant1: /* @__PURE__ */ e([
      "width:100%;height:auto;",
      " svg{width:100%;height:100%;}"
    ], t({
      width: [
        "5.2rem",
        null,
        "6.7rem"
      ],
      height: [
        "4rem",
        null,
        "5rem"
      ],
      mb: [
        0,
        null,
        "xs"
      ]
    }))
  }
};
export {
  a as default
};
